const SAFE_SCHEME_RE = /^(https?:|mailto:|tel:)/i;

export function safeHref(raw: string): string | null {
  const url = raw.trim();
  if (!url) return null;
  if (SAFE_SCHEME_RE.test(url)) return url;
  if (/^[a-z][a-z0-9+.-]*:/i.test(url)) return null;
  if (url.startsWith('//')) return `https:${url}`;
  if (url.startsWith('/') || url.startsWith('#')) return null;
  if (/^[\w-]+(\.[\w-]+)+/.test(url)) return `https://${url}`;
  return null;
}
